module.exports = __webpack_public_path__ + "img/franchising_help_construction2.1d866118.png";